import ProteinAnnotationsView, {
  ProteinAnnotationsViewOptions,
  ProteinAnnotationView,
} from 'molbio/aa-sequences/AaSequenceAnnotationsView';
import {ProteinAnnotationVersion} from 'molbio/aa-sequences/util/AaSequenceConstants';
import Type from 'molbio/maps/Type';
import ProteinAlignmentTabState from 'molbio/tabstates/AaSequenceAlignmentTabState';

interface ProteinAlignmentAnnotationsViewOptions extends ProteinAnnotationsViewOptions {
  annotations: Array<ProteinAnnotationVersion>;
}

export default class ProteinAlignmentAnnotationsView extends ProteinAnnotationsView {
  override tabstate!: ProteinAlignmentTabState;
  annotations!: Array<ProteinAnnotationVersion>;

  constructor(options: ProteinAlignmentAnnotationsViewOptions) {
    super(options);
    this.annotations = options.annotations;
    this.className = 'proteinAlignmentAnnotations';
  }

  override getPolymerLength(): number {
    return this.tabstate.getPolymerLength();
  }

  override contextMenuOptions(): Array<string> {
    return [];
  }

  override shouldSyncToStore(): boolean {
    return false;
  }

  override isAnnotationHovered(annotation: ProteinAnnotationVersion): boolean {
    return false;
  }

  override isAnnotationSelected(annotation: ProteinAnnotationVersion): boolean {
    return false;
  }

  override getProteinId(): string | null {
    return null;
  }

  override getAnnotations(): Array<ProteinAnnotationVersion> {
    return this.annotations;
  }

  override getResiduesType(): Type {
    return this.tabstate.getType();
  }

  override clickAction(e: MouseEvent, d: ProteinAnnotationView): void {
    this.tabstate.get('selection').setEndpoints(d.start(), d.end());
  }

  override dblClickAction(e: MouseEvent, d: ProteinAnnotationView): void {}
}
